(function () {
    "use strict";

    angular
        .module("iMatApp")
        .factory("directUploadFileService", directUploadFileService);

    directUploadFileService.$inject = ["$q", "$log", "Upload", "uuid2", "eventService", "guard", "directUploadFileSettings"];

    function directUploadFileService($q, $log, fileUploader, uuid2, eventService, guard, settings) {
        var uploadProgressEventName = "UploadProgressEvent";

        return {
            uploadFile: uploadFile,
            validateFile: validateFile,
            isUploadInProgress: fileUploader.isUploadInProgress,
            subscribeUploadProgress: subscribeUploadProgress
        };

        function uploadFile(file, canceler) {
            guard.argumentIsObject(file, "file");

            return validateFile(file).then(function (file) {
                return directUploadToCloud(file, canceler);
            });
        }

        function directUploadToCloud(file, canceler) {
            var fileId = uuid2.newguid();
            var options = createUploadOptions(fileId, file);

            var uploadPromise = fileUploader.upload(options);

            if (angular.isObject(canceler)) {
                canceler.then(function () {
                    if (uploadPromise.isCanceled) {
                        return;
                    }

                    uploadPromise.isCanceled = true;
                    uploadPromise.abort();
                });
            }

            return uploadPromise
                .then(function () {
                    return {
                        fileId: fileId,
                        fileName: file.name
                    }
                },
                uploadFailed,
                notifyUploadProgress);
        }


        function subscribeUploadProgress($scope, callback) {
            eventService.subscribe($scope, uploadProgressEventName, callback);
        }

        // ---------------------------------------------------------------------------------------------

        function createUploadOptions(fileID, file) {
            var options = {
                url: "https://" + settings.uploadFileFormData.bucketName + ".s3.amazonaws.com",
                method: "POST",
                data: {
                    key: "uploads/" + fileID,
                    acl: "private",
                    Policy: settings.uploadFileFormData.policy,
                    "X-Amz-Signature": settings.uploadFileFormData.signature,
                    "X-Amz-Algorithm": "AWS4-HMAC-SHA256",
                    "X-Amz-Credential": settings.uploadFileFormData.credential,
                    "X-Amz-Date": settings.uploadFileFormData.date,
                    "Content-Type": file.type !== "" ? file.type : "application/octet-stream",
                    file: file
                }
            };

            return options;
        }

        function validateFile(file) {
            if (!isFileTypeValid(file)) {
                return $q.reject("Invalid file type");
            }

            if (!isFileNameLengthValid(file)) {
                return $q.reject("File name too long");
            }

            if (!validateFileSize(file)) {
                return $q.reject("File size too big");
            }

            return $q.resolve(file);
        }

        function isFileTypeValid(file) {
            var fileExtension = file.name.substr(file.name.lastIndexOf("."));
            fileExtension = fileExtension.toLowerCase();

            var allowedExtensions = settings.allowedFileExtensions;

            return _.contains(allowedExtensions, fileExtension);
        }

        function isFileNameLengthValid(file) {
            return file.name.length <= settings.maxFileNameLength;
        }

        function validateFileSize(file) {
            return file.size / 1024 < settings.maxFileSizeKb;
        }

        function uploadFailed(e) {
            eventService.notify(uploadProgressEventName, -1);

            // if canceled by user
            if (e.config._deferred && e.config._deferred.promise.isCanceled) {
                return $q.reject("CANCELED");
            }

            return $q.reject('Upload file failed');
        }

        function notifyUploadProgress(evt) {
            var uploadProgress = parseInt(100.0 * evt.loaded / evt.total);
            eventService.notify(uploadProgressEventName, uploadProgress);

            return uploadProgress;
        }
    }
}());